import { Skeleton } from "@components/Skeleton/Skeleton";

export const PlanCardSkeleton = () => {
  return [...(Array(3) as unknown[])].map((_, i) => (
    <Skeleton key={i} className="h-96 rounded-xl" />
  ));
};
